<template>
  <div>
     <div class="box">
      <p class="return" @click='$router.go(-1)'>返回</p>
      <span class="line">|</span>
      <p class="contract back"  @click="backTo">项目列表</p>
      <span class="lines">></span>
      <p class="contract">关联设置</p>
    </div>
    <div class="sign adaptation" style="padding: 0">
      <div class="tab_nav">
        <div class="tab_search">
          <div>
            <span class="checkedss"> RPO关联项目 </span>
          </div>
        </div>  
      </div>

      <div class="table" style="margin-top:20px">
        <div class="tab" v-for="(v, k) in list" :key="k">
          <!-- <div
            v-if="btnPermissionsStr.includes('func:ssgshowproject')"
            class="name"
          >
            <div v-if="v.applyRelationState" class="newsplay">新申请</div>

            <p>
              <span style="cursor: pointer" @click="junpSsg(v.id)">
                {{ v.projectName }}
              </span>
            </p>
          </div> -->
          <div class="ynum three">
            <div v-if="v.state == 1" class="newsplay">新申请</div>
            <p style="color:#9393a2">项目名称</p>
            <p style="margin-top:10px">{{ v.rpoProjectName }}</p>
          </div>
             <div class="ynum three">
            <p>RPO执行公司</p>
            <p  style="margin-top:10px">{{ v.rpoImplementCompany }}</p>
          </div>
         <div class="ynum three">
            <p>需求方</p>
            <p  style="margin-top:10px">{{ v.employer }}</p>
          </div>
          <div class="ynum three">
            <p>RPO项目经理</p>
            <p  style="margin-top:10px">{{ v.rpoManager }}</p>
          </div>

          <div class="ynum three">
            <p>申请时间</p>
            <p  style="margin-top:10px">{{ v.creatTime}}</p>
          </div>
          <div class="name">
            <p style="font-size: 12px; color: #9393a2; text-align: center">
              操作
            </p>
            <div  style="margin-top:10px" class="opera">
              <div
                v-if="v.state == 1 || v.state !== 2"
              >
                <span @click="disagree(v.rpoId,v.rpoProjectName,v.id)">拒绝关联</span>
              </div>
              <div>
                <span
                  v-if="v.state == 1 || v.state !== 2"
                  @click="agree(v.rpoId,v.rpoProjectName,v.id)"
                  >同意关联</span
                >
              </div>
              <div>
                <span
                  v-if="v.state==2"
                  @click="details(v.id,v.ssgProjectId,v.rpoId,v.rpoProjectName)"
                  >查看已交付候选人</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bgnull" v-if="list.length == 0">
          <div class="bg"></div>
          <div class="span">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.maskshow = this.$route.params.maskshow;
    this.masktype = this.$route.params.masktype;
    this.totals = this.$route.params.totals;
    this.noconnect = this.$route.params.noconnect;
    this.yesORno = this.$route.params.yesORno;
    this.loadData();
    this.getBatchTaskExecuteInfo();
    this.$once("hook:beforeDestroy", () => {
      clearTimeout(this.timeout);
    });
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");

    // this.$nextTick(() => {
    //   if (this.yesORno) {
    //     (this.maskshow = true),
    //       (this.masktype = "pushFile"),
    //       (this.totals = this.$route.params.totals),
    //       (this.noconnect = this.$route.params.noconnect);
    //   }
    // });
  },
  data() {
    return {
      inputcontent:'',
      rules: {
        messger: [
          {
            required: true,
            message: "请选择项目经理",
            trigger: "change",
          },
        ],
        payrollSubject: [
          {
            required: true,
            message: "请选择发新主体",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入您的项目名称",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        projectID: [
          {
            required: true,
            message: "请输入您的项目标识",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        isMust: [
          {
            required: true,
            message: "请输入您的项目编号",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
      },
      addForm: {
        name: "",
        isMust: "",
        ssgProjectCode: this.$route.query.code,
        messger: "",
        payrollSubject: "",
        projectID: "",
      },
      payList: [],
      btnPermissionsStr: {},
      radio: 1,
      yesORno: false,
      list: [],
      tasknumber: 0,
      taskList: [{}],
      badgeHidden: true,
      maskshow: false,
      masktype: "",
      pushEmployTotal: 0,
      noconnect: 0,
      type: 2,
      noticeStatus: 1,
      pageNo: 1,
      pageSize: 10,
      id: "",
      total: 0,
      form: {
        name: "",
        userName: "",
        status: "",
      },
    };
  },
  watch: {
    // pageNo: function (val, oldVal) {
    //   this.$refs.page.page = val;
    // },
  },
  created() {
    this.loadData();
    // this.yesORno = this.$route.params.yesORno;
  },
  methods: {
    details(id,projectId,rpoId,name) {
      // if (permiss == false) {
      //   this.$message.error("您没有查看嗖嗖发薪项目权限");
      //   return;
      // } else {
      this.$router.push({
         path: "/ssgSplat/settings/relateRpoDetails" ,
         query:{
         id:id,
         projectId:projectId,
         rpoId:rpoId,
         name:name
         }
         });
       
      // }
    },
  

    
    back() {
      this.$router.push({ path: "/main" });
    },
         backTo() {
      this.$router.push({
         path: "/ssgSplat"
         
         });
    },
  
 
    loadData() {
      const params = {
        ssgProjectId: this.$route.query.id,
        // ssgProjectId: 323,
        
      };
      return this.$axios
        .get("/rpoProjectRelvance/queryRpoProjectList", {
          params,
        })
        .then((res) => {
          this.list = res.data.data.list;
          // this.total = res.data.data.total;
          this.$root.$emit("", res.data.data.newRequestNum);

          //   if( this.pageNo!==1 && this.list.length==0){
          //     this.pageNo = this.pageNo-1
          //     this.loadData()
          //   }
          // this.noticeStatus = res.data.data.noticeStatus -1;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    disagree(rpoid,name,id) {
      this.$prompt(
        `<p style="margin-bottom:10px;font-size: 16px;font-weight: bold;color: #303140;">您确定<span  style="color:#FF6752">拒绝</span>关联【${name}】项目吗？</p><p style="margin-top:15px;width:80px"> <span style="color:#FE6752;vertical-align: middle">*</span> 拒绝原因       
        </p>`,
        "关联项目",
        {
          confirmButtonText: "确定拒绝",
          cancelButtonText: "我再想想",
          dangerouslyUseHTMLString: true,
          iconClass: "el-icon-caveat",
          inputPlaceholder:'请输入拒绝原因',
          inputPattern:/^[^\s]+[\s]*.+$/,
          inputErrorMessage: '请输入最少两个字符的拒绝原因',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
            
              //  .then((action) => {
                

          this.$axios
            .put("rpoProjectRelvance/relevanceYesOrNO?rpoId=" + rpoid + "&msg=" + instance.inputValue+'&state='+3+'&id='+id)
            .then((res) => {
              if (res.data.status == 1) {
                done();
                this.$message.success(res.data.message);
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            });
        // })
        // .catch(() => {});

              
            } else {
              done();
            }
          }
        }

        
      )
    
        
    },
    agree(rpoid,name,id) {
      this.$confirm(
        `<p style="margin-bottom:10px;font-size: 16px;font-weight: bold;color: #303140;">您确定<span  style="color:#3AC697">同意</span>关联【${name}】项目吗？</p><p>关联RPO项目后，接受offer的候选人会推送到嗖嗖管进行入职管理</p>`,
        "关联项目",
        {
          confirmButtonText: "确定同意",
          cancelButtonText: "我再想想",
          dangerouslyUseHTMLString: true,
          iconClass: "el-icon-caveat",
        }
      )
        .then(() => {
          this.$axios
            .put("rpoProjectRelvance/relevanceYesOrNO?rpoId=" + rpoid + "&state=" + 2+'&msg='+''+'&id='+id)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },

    cur(val) {
      this.pageNo = val;
      this.loadData();
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  .logo {
    margin-left: 30px;
  }
}
.top {
  padding: 30px 0 0 0;
  .notice {
    color: #303140;
    font-weight: bold;
    font-size: 20px;
  }
  .notices {
    color: #303140;
    font-weight: bold;
    span {
      color: #6669e3;
      margin-left: 10px;
    }
  }
}
.sign {
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }

  .table {
    width: 100%;

    .tab {
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      border: 1px solid #d9dbe2;
      border-radius: 12px;
      margin-bottom: 15px;
      padding: 14px 0;
      box-sizing: border-box;
      position: relative;

      .name {
        width: 139px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        color: #6669e3;
        border-left: 1px solid #f2f5f8;
      }
      .status {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: inherit;
        font-size: 12px;
        color: #9393a2;
      }

      .three {
        width: 18%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;

        p:first-child {
          color: #9393a2;
        }

        p:last-child {
          color: #545566;
        }
      }

      .axis {
        width: 40%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .bgnull {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .bg {
        width: 214px;
        height: 110px;
        background-image: url(../../../assets/img/10wvB0eE.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 214px 110px;
        margin-top: 100px;
      }
    }
  }
}

.pbg {
  width: 75px;
  display: flex;
  justify-content: center;

  i {
    font-size: 54px;
    color: #3bc798;
  }
}

.part {
  font-size: 18px;
  margin-left: 10px;

  p {
    margin: 5px 0;

    .red {
      color: #ff6752;
    }

    .green {
      color: #3bc798;
    }
  }
}
.submess {
  .form {
    display: flex;
    /*justify-content: space-around;*/
    .img {
      background-image: url("../../../assets/img/warning.png");
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
    }
    .linhin {
      margin-left: 30px;
      height: 100px;
      line-height: 30px;
      .p1 {
        font-size: 14px;
        color: #303140;
        font-weight: bold;
      }
      .p2 {
        color: #303140;
      }
      .rad {
        color: #303140;
        .no {
          display: block;
          margin-left: 90px;
        }
      }
    }
  }
}
.filter {
  width: 100%;
  height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
  .content {
    display: flex;
  }
  size {
    font-size: 12px;
    font-weight: 400;
    color: rgba(84, 85, 102, 1);
    margin-left: 10px;
    margin-right: 10px;
  }
}
.opera {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #6669e3;
  span {
    margin: 0 5px;
    color: #6669e3;

    cursor: pointer;
  }
}
.span_bgc {
  padding: 3px 5px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  font-weight: 400;
  width: 50px;
  color: rgba(245, 116, 116, 1);
}

.span_bgc4 {
  padding: 3px 5px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
  width: 50px;
  border: 1px solid rgba(183, 225, 211, 1);
}
.checkedss {
  width: 192px;
  height: 37px;
  font-size: 24px;
  font-weight: bold;
  color: #303140;
  line-height: 36px;
}
.newsplay {
  width: 48px;
  height: 22px;
  background: #ff6752;
  border-radius: 0px 4px 4px 0px;

  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: absolute;
  left: 0;
  top: 7px;
}
.el-icon-question:before {
  content: "\e7a4";
  position: absolute;
  padding-left: 10px;
  margin: -10px auto;
}

.title {
  font-size: 6px;
  font-weight: 400;
  color: #545566;
}
.el-message-box__input /deep/ .el-input{
  width: 0;
}

</style>
